<section class="footer" id="footer">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-3">
        <svg-icon src="/assets/images/svg-icons/logo.svg" [svgStyle]="{ 'width.px': '151', 'height.px': '40' }"
          class="mb-3 d-block"></svg-icon>
        <p class="font-14 d-none d-md-block mwx-250">{{ 'footer_navigation.disclaimer_desc' | translate }}</p>
        <p></p>
      </div>
      <div class="col-6 col-lg-3">
        <h2 class="font-16 fw-normal margin-20 ms-3 d-none d-md-block">{{ 'footer_navigation.title_1' | translate }}
        </h2>
        <ul class="text-left d-flex flex-column gap-12 mb-0">
          <li class="font-14" *ngFor="let item of links" type="none">
            <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" fragment="{{ item.routeName }}"
              title="{{ item.routeName }}" class="">{{ item.title | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="col-6 col-lg-3">
        <h2 class="font-16 fw-normal margin-20 d-none d-md-block ms-md-3 ms-lg-0">{{ 'footer_navigation.title_2' |
          translate
          }}</h2>
        <div class="d-flex flex-column gap-12">
          <a *ngFor="let item of items" href="{{ item.link }}" class="text-left" target="_blank">
            <li class="font-14 ms-3 ms-lg-0" type="none">{{ item.title | translate }}</li>
          </a>
        </div>
      </div>
      <div class="col-lg-3">
        <h2 class="font-16 fw-normal d-none d-md-block margin-20">{{ 'footer_navigation.title_3' | translate
          }}
        </h2>
        <div class="copyright mt-3 mt-md-0">
          <div class="my-3 px-3 px-lg-0 d-flex">
            <a *ngFor="let item of social" href="{{ item.link }}"
              class="link socials d-flex justify-content-center align-items-center" target="_blank">
              <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
            </a>
          </div>
          <!-- <p class="d-block d-md-none font-14 px-3">{{ 'footer_navigation.address' | translate }}</p>
          <p class="d-block d-md-none font-14 px-3">{{ 'footer_navigation.disclaimer' | translate }}</p>
          <p class="font-14 px-3 px-lg-0">{{ 'footer_navigation.copyright' | translate }}</p> -->
        </div>
      </div>
    </div>
    <div class="line mt-0 mt-md-5"></div>
    <div class="links d-flex flex-column flex-md-row justify-content-between font-14 gap-3">
      <span class="text-center">{{ 'footer_navigation.copyright' | translate }}</span>
      <div class="docs d-flex justify-content-center">
        <a *ngFor="let doc of docs" href="{{ doc.link }}" class="link" target="_blank">
          {{ doc.title | translate
          }}
        </a>
      </div>
    </div>
    <p class="font-12 disclaimer text-start mt-4">{{ 'footer_navigation.disclaimer' | translate
      }}</p>

  </div>
</section>